import React, { useState, useRef, useEffect, useMemo } from "react";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line,
  CartesianGrid, ResponsiveContainer, Cell
} from "recharts";

const Report_Performance = () => {

  const inputRefs = useRef([]);

  const [filters, setFilters] = useState({
    month: "",
    year: "",
    category: "0"   // default All
  });

  const [rows, setRows] = useState([]);
  const [genMasters, setGenMasters] = useState([]);

  const [trendData, setTrendData] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);

  useEffect(() => {
    loadGeneralMasters();
  }, []);

  const loadGeneralMasters = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`,
        { params: { type: 'CATG' } });

      setGenMasters(response.data || []);

    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Load Data
  const handleRunReport = async () => {

    if (!filters.month) {
      toast.error("Please select Month and Year");
      return;
    }

    if (!filters.year) {
      toast.error("Please select Month and Year");
      return;
    }

    try {

      const res = await axios.get(`${BASE_URL}/api/rpt_Performance_KPI_Bar`, {
        params: filters
      });

      if (res.data && res.data.length > 0) {
        setRows(res.data);
      } else {
        setRows([]);
        toast.error("No data found");
      }

    } catch (err) {
      console.error(err);
      toast.error("Error loading data");
    }
  };

  const handleBarClick = async (data) => {

    try {

      const row = data.payload;

      setTrendData([]);
      setSelectedEmp(row); 

      const res = await axios.get(`${BASE_URL}/api/rpt_Performance_KPI_Trend`, {
        params: {
          emp_id: row.emp_id,
          year: filters.year,
          month: filters.month
        }
      });
      //console.log('res.data =================> ', res.data);
      setTrendData(res.data || []);

    } catch (err) {
      console.error(err);
      toast.error("Error loading trend");
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          background: "#fff",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px"
        }}>
          <div>👤 : <strong>{data.emp_name}</strong></div>
          <div>MD KPI: <strong>{data.md_kpi_perc}%</strong></div>
          <div>MD Remarks:{data.md_rem}</div>
        </div>
      );
    }
    return null;
  };

  // 🎨 Color Logic
  const getBarColor = (value) => {
    if (value <= 35) return "#dc3545";
    if (value <= 50) return "#F57C00";
    if (value <= 65) return "#FFEA00";
    if (value <= 85) return "#9C27B0";
    //if (value <= 75) return "#664d03"; 
    return "#198754";
  };

  // 📊 Limit data if "All"
  const chartData = useMemo(() => {
    return filters.category === "0"
      ? rows.slice(0, 15)
      : rows;
  }, [rows, filters.category]);

  // 🏆 Top Performer
  const topEmp = chartData.length > 0
    ? chartData.reduce((max, curr) =>
      curr.md_kpi_perc > max.md_kpi_perc ? curr : max
    )
    : null;

  const getMonthName = (m) => [
    "", "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ][m];

  const TrendTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {

      const data = payload[0].payload;

      return (
        <div style={{
          background: "#fff",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontWeight: "bold"
        }}>
          {getMonthName(data.kpi_month)} {data.md_kpi_perc}%
        </div>
      );
    }
    return null;
  };

  return (

    <Container fluid className="p-3">

      {/* HEADER */}
      <Card className="p-3 mb-3">

        <Row>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Month</InputGroup.Text>
              <select
                className="form-select"
                onChange={(e) => setFilters({ ...filters, month: e.target.value })}
              >
                <option value="">-- Month --</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Year</InputGroup.Text>
              <input
                type="number"
                className="form-control"
                style={{ textAlign: "right" }}
                onChange={(e) => setFilters({ ...filters, year: e.target.value })}
              />
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text>Category</InputGroup.Text>
              <select
                className="form-select"
                value={filters.category}
                onChange={(e) => setFilters({ ...filters, category: e.target.value })}
              >
                <option value="0">All Staff</option>
                {genMasters.map(gm => (
                  <option key={gm.gen_id} value={gm.gen_id}>
                    {gm.gen_desc}
                  </option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <Button variant="primary" onClick={handleRunReport}>
              Run Report
            </Button>
          </Col>

        </Row>

      </Card>

      {/* GRAPH */}
      <Card className="p-3">

        {chartData.length > 0 && (

          <div style={{ overflowX: "auto" }}>
            <h5 className="mb-2">📊 Monthly Performance (Managing Director KPI %)</h5>

            <BarChart
              data={chartData}
              width={Math.max(chartData.length * 70, 500)}
              height={400}
            >

              <CartesianGrid strokeDasharray="3 3" />

              <XAxis
                dataKey="first_name"
                //angle={-30}
                //angle={-30}
                //textAnchor="end"
                textAnchor="middle"
                height={80}
                tick={{
                  fill: "#000",
                  fontWeight: "bold",
                  fontSize: 14
                }}
              />

              <YAxis domain={[0, 100]}
                tick={{
                  fill: "#000",
                  fontWeight: "bold",
                  fontSize: 16
                }} />

              {/* <Tooltip formatter={(value, name) => [`${value}%`, "Final MD Perc :"]}
              labelFormatter={(label) => `👤 ${label}`} /> */}

              <Tooltip content={<CustomTooltip />} />

              <Bar dataKey="md_kpi_perc" barSize={40} label={{ position: "top", fontWeight: "bold" }}
                onClick={handleBarClick}>
                {chartData.map((entry, index) => (
                  <Cell
                    key={index}
                    fill={getBarColor(entry.md_kpi_perc)}
                  />
                ))}
              </Bar>

            </BarChart>

            {/* Start : Trend chart */}
            {/* {console.log("trendData:", trendData, "selectedEmp:", selectedEmp)} */}
            {trendData.length > 0 && selectedEmp && (

              <div style={{ marginTop: "30px" }}>

                <h5>
                  📈 Performance Trend: {selectedEmp.emp_name}
                </h5>

                <LineChart
                  width={600}
                  height={300}
                  data={trendData}
                >

                  <CartesianGrid strokeDasharray="3 3" />

                  {/* <XAxis dataKey="kpi_month" /> */}
                  <XAxis dataKey="month_name" />

                  <YAxis domain={[0, 100]} />

                  {/* <Tooltip formatter={(v) => `${v}%`} /> */}
                  <Tooltip content={<TrendTooltip />} />

                  <Line
                    type="monotone"
                    dataKey="md_kpi_perc"
                    stroke="#0d6efd"
                    strokeWidth={3}
                  />

                </LineChart>

              </div>

            )}
            {/* End : Trend chart */}

          </div>
        )}

        {chartData.length === 0 && (
          <div className="text-center text-muted">
            No data to display
          </div>
        )}


      </Card>

    </Container>
  );
};

export default Report_Performance;
